"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlammableCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FlammableCircleFilled = function FlammableCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 13.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25h-6.5a.25.25 0 01-.25-.25v-.5a.25.25 0 01.25-.25h6.5zM9.104 1.547a.25.25 0 01.396.203c0 1.168.588 1.959 1.269 2.875.735.99 1.568 2.111 1.705 3.9 0 0 .026.35.026.475a4.505 4.505 0 01-4.487 4.5H8a4.505 4.505 0 01-4.495-4.755C3.58 6.19 4.837 5.55 4.891 5.525a.249.249 0 01.357.19c.002.017.233 1.542 1.252 1.76.005-.657.034-1.652.258-2.536C7.079 3.669 8 2.337 9.104 1.547zm-.767 7.216a2.43 2.43 0 00-.506.958c-.088.37-.096.781-.096 1.137a.25.25 0 01-.25.25c-.42 0-.68-.286-.825-.597-.077.168-.148.422-.158.794-.002.037-.002.067-.002.097C6.5 12.282 7.173 13 8 13s1.5-.717 1.5-1.598c0-.046-.003-.09-.006-.133-.053-.725-.352-1.15-.641-1.56-.202-.288-.41-.582-.516-.946z",
    fill: "currentColor"
  }));
};

exports.FlammableCircleFilled = FlammableCircleFilled;
var _default = FlammableCircleFilled;
exports.default = _default;